import React from 'react';
import { tomos } from '../data/tomos';
export function Solution() {
  return <section id="solucion" className="w-full bg-paper-soft py-14 sm:py-20" data-id="element-77" data-mp="1ekkrb65q5icy">
      <div className="mx-auto max-w-6xl px-5" data-id="element-78" data-mp="1emotnjnz69b4">
        <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-14" data-id="element-79" data-mp="10tz8tik6nafl">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/3c0e89a0-39ee-43a7-b322-97e46c1d499b.jpg" alt="Megapack Adiós Piojos 2026: seis tomos digitales y acceso en tablet" className="w-full rounded-2xl bg-white object-contain" data-id="element-80" data-mp="15s0tg7x9bht6" />

          <div data-id="element-81" data-mp="hulakoff7dja">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-flame-dark" data-id="element-82" data-mp="huv60rj8icwd">
              La solución
            </p>
            <h2 className="mt-3 text-3xl font-black leading-[1.08] tracking-tight text-ink sm:text-[2.6rem]" data-id="element-83" data-mp="mty8q5bqs716">
              Megapack Adiós Piojos 2026
            </h2>
            <p className="mt-5 text-lg leading-relaxed text-ink-soft" data-id="element-84" data-mp="2h7pf8vyryase">
              El resultado de años de investigación en pediculosis resistente,
              empaquetado en un sistema digital de{' '}
              <strong className="font-bold text-ink" data-id="element-85" data-mp="2zyeytb1whhr">6 tomos</strong> y{' '}
              <strong className="font-bold text-ink" data-id="element-86" data-mp="gqaal26ugydn">5 bonos de regalo</strong>. Todo lo
              que necesitas, en orden, desde la primera aplicación hasta la prevención
              permanente.
            </p>
          </div>
        </div>

        <ol className="mt-12 grid gap-x-10 gap-y-8 sm:grid-cols-2 lg:grid-cols-3" data-id="element-87" data-mp="3k7sif9mma5e2">
          {tomos.map(tomo => <li key={tomo.numero} className="flex gap-4 border-t border-paper-line pt-5" data-id="element-88" data-mp="3g7rtgv1w6bsr">
              <span className="mt-0.5 font-mono text-sm font-bold tabular-nums text-flame" data-id="element-89" data-mp="3u6rhc0hkymnv">
                {tomo.numero}
              </span>
              <div data-id="element-90" data-mp="19ez52idea5gf">
                <h3 className="text-base font-bold leading-snug text-ink" data-id="element-91" data-mp="19efujmq2qjcf">
                  {tomo.titulo}
                </h3>
                <p className="mt-1.5 text-sm leading-relaxed text-ink-muted" data-id="element-92" data-mp="14fmlc6htlei2">
                  {tomo.descripcion}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}